export class InsertRequestDTO{
    constructor(){
        this.IdAzienda,
        this.RowsToInsert = []
    }
}

export class InsertRowDTO{
    constructor(){
        this.ProdottoInfo,
        this.Quantita,
        this.Prezzo,
        this.CodiceDeposito,
        this.IdConfigurazione,
        this.DataEvasione,
        this.SePersonalizzare,
        this.SeArticoloServizio,
        this.SeMerceCampione,
        this.SeMerceFullCustom,
        this.NextStepCarrello,
        this.SeReimbusto,
        this.PrezzoReimbusto,
        this.CodiceIva,
        this.CodiceIvaReimbusto
    }
}